import React, { useState } from 'react';
import SpeedTestModal from './SpeedTestModal';

/**
 * Compact pill matching LiveDataStatusBadge styling. Opens a modal that
 * runs an on-demand download/upload speed test.
 */
const SpeedTestButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Internet speed test"
        aria-label="Internet speed test"
        className="flex items-center gap-2 px-2.5 py-1 rounded-full shadow text-xs font-medium transition-colors bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"
      >
        <span>Speed</span>
      </button>
      {open && <SpeedTestModal onClose={() => setOpen(false)} />}
    </>
  );
};

export default SpeedTestButton;
